import {load} from '@shopify/theme-sections';
import '../../styles/templates/page.scss';
import {lazyScript} from '../ui/lazy-script';

lazyScript();

load('*');



